import Container from "@client/content/Containers/container";
import { ImageEntity } from "@client/content/controls/Image/container";
import { EMPTY_MODULE_API_INFO } from "@client/content/lib/consts";
import { getContainerProps, getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { Loading } from "@client/controls/Loading/component";
import { getUnwrapResponse } from "@client/lib/api";
import { getNoImageUrl } from "@client/lib/assets";
import { type Entity, type WithIsEditMode } from "@client/types";
import appInfo from "@common/appInfo";
import { getMediaUrl } from "@common/components/Media/lib";
import { formatToHtml } from "@common/lib/format";
import { usePromise } from "@common/lib/hooks";
import classNames from "classnames";
import * as React from "react";
import api from "./api";
import { DUMMY_PROFILE } from "./lib";

import "./style.less";

export type MapProps = RootContainerProps &
  WithIsEditMode & {
    imageOrientation: "top" | "left" | "right" | undefined;
    items: Entity[];
    profileType: "affiliate" | "loggedIn";
    textStyle: React.CSSProperties;
  };

export type Props = MapProps;

const Content = (props: Props) => {
  const [response, isLoading] = usePromise({
    fn: getUnwrapResponse(api.init),
    args: [EMPTY_MODULE_API_INFO, { profileType: props.profileType }],
    shouldLoad: props.profileType === "affiliate" || (!!appInfo.user && !appInfo.user.isSuperUser),
    reload: props.profileType
  });

  if (isLoading) return <Loading />;

  const profile = response ?? (props.isEditMode ? DUMMY_PROFILE : null);

  if (!profile) return null;

  return (
    <div
      className={classNames("wsc_content_mini_profile", {
        image_top: props.imageOrientation === "top",
        image_left: props.imageOrientation === "left",
        image_right: props.imageOrientation === "right"
      })}
    >
      {props.imageOrientation && (
        <ImageEntity
          {...getEntityRef(props)}
          className="image"
          src={
            profile.profilePictureMediaSourceKey && profile.profilePictureMediaSourceId
              ? getMediaUrl(profile.profilePictureMediaSourceKey, profile.profilePictureMediaSourceId)
              : getNoImageUrl()
          }
          useMaxValues={false}
        />
      )}
      <div style={props.textStyle}>
        {props.items
          .map((x) =>
            x.settings?.caption
              ? formatToHtml(x.settings.caption)
              : profile.items.find((f) => f.fieldId === x.data.id)?.value
          )
          .filter((x) => !!x)
          .map((x, i) => (
            <div key={i} dangerouslySetInnerHTML={{ __html: x }}></div>
          ))}
      </div>
    </div>
  );
};

export default (props: Props) => (
  <Container {...getContainerProps(props)}>
    <Content {...props} />
  </Container>
);
